/**
 * The base resource needs to be declared in this file and not imported,
 * because it must resolve to a string directly, otheriwse it will not work in
 * the getModels method.
 */
import { isSubscriptionJourney, isOneShop } from '../../helpers'

const BASE_RESOURCE = 'base'

interface ReactConfig {
  brand?: string
}

interface WindowWithReactConfig extends Window {
  reactConfig?: ReactConfig
}

export const getBrandName = (): string | undefined => {
  const windowConfig = window as WindowWithReactConfig

  if (
    typeof windowConfig.reactConfig === 'object'
    && windowConfig.reactConfig.brand !== '%brand%'
  ) {
    return windowConfig.reactConfig.brand
  }

  return process.env.REACT_APP_WEBSITE_BRAND
}

export const getPages = (brand: string) => {
  let brandWithProduct = brand

  if (isSubscriptionJourney()) {
    brandWithProduct = `${brand}-subscription`
  } else if (isOneShop()) {
    brandWithProduct = `${brand}-oneshop`
  }

  return import(`../../resources/${brandWithProduct}/pages/index.json`).catch(
    () => {
      return import(`../../resources/${BASE_RESOURCE}/pages/index.json`)
    },
  )
}

export const getModels = (brand: string) => {
  return import(`../../resources/${brand}/models`).catch(() => {
    return import(`../../resources/${BASE_RESOURCE}/models`)
  })
}
